import React, { Component, Fragment } from 'react';
import { withStyles } from '@material-ui/core/styles';
import TableCell from "@material-ui/core/TableCell";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import { connect } from 'react-redux';
import * as actions from '../../store/actions/index';
import PropTypes from 'prop-types';

const styles = theme => ({
    root: {
        //width: '100%',
        // height: '100vh', /* Magic here */
        //marginLeft:'28%'

        //margin: '0 auto',
    },
    uploadDocs:{
        marginTop:'20px'
        //margin: '0 auto',
    },
    formControl: {
        margin: theme.spacing.unit * 3,
    },
    group:{
    },
    radio: {
        '&$checked' : {
            color: '#B71C1C',
        },
    },
    checked: {},
    progress: {
        /*display: 'flex',
        flexDirection: 'row',
        flexWrap: 'wrap',
        justifyContent: 'center',
        alignItem: 'center',*/
        flexDirection: 'column',
        margin: theme.spacing.unit * 3,
    },
    button:{
        display:'flex',
        //justifyContent: 'center',
        margin: '0 Auto',
    },
    margin : {
        marginTop:'40px',
        fontWeight: 'bold'
    },
    row:{
        border:'none',
        fontSize:'13px',
        fontWeight:'normal'
    }
});

class DeadlinePanel extends Component {
    state = {
      AddNoOfDays:0,
      typeOfAccount:localStorage.getItem('typeOfAccount'),
      uniqueId: localStorage.getItem('token')
    };

    componentWillMount(){

    }

    componentDidMount(){
        
    }

    render(){
        const { classes } = this.props;
        var disableUploadDoc = false;
        var dateOfProceeding = '';

        let userType = '';
        if (this.props.caseData.claimantUniqueId == this.state.uniqueId) {
            userType = 'claimant';
        } else if (this.props.caseData.respondentUniqueId == this.state.uniqueId) {
            userType = 'respondent';
        }

        if(userType == 'claimant'){
            if (this.props.caseData.claimant_payment_date !== undefined){
                dateOfProceeding = new Date(this.props.caseData.claimant_payment_date)
            }
        }
        else if (userType == 'respondent'){
            if (this.props.caseData.respondent_payment_date !== undefined){
                dateOfProceeding = new Date(this.props.caseData.respondent_payment_date)
            }
        }

        var sevenDaysLaterTime = new Date(this.props.caseData.timestampForCaseProcedure)
        sevenDaysLaterTime.setDate(sevenDaysLaterTime.getDate() + 7);
        
        var now = new Date();
        var canChooseArbitrator = true;
        var responseTimestamp;

        if (this.props.caseData.response !== undefined){
          responseTimestamp = new Date(this.props.caseData.response.timestampForCaseProcedure)

          var threeDaysLaterTimeAfterResponse = new Date(this.props.caseData.response.timestampForCaseProcedure)
          threeDaysLaterTimeAfterResponse.setDate(threeDaysLaterTimeAfterResponse.getDate() + 3);
          
          if (now >= threeDaysLaterTimeAfterResponse){
            canChooseArbitrator = false
          }

          if (this.props.caseData.requireAdminChooseArbitrator == true){
            canChooseArbitrator = false
          }

          if (now < threeDaysLaterTimeAfterResponse){
              var inTn = setInterval(()=>{
                  if (now >= threeDaysLaterTimeAfterResponse){
                      canChooseArbitrator = false;
                      clearInterval(inTn)
                  }
              })
          } 
        }
        else if (this.props.caseData.response == undefined){
          // console.log('now: '+now)
          // console.log('sevenDaysLaterTime: '+sevenDaysLaterTime)
            // if (now <= sevenDaysLaterTime){
              canChooseArbitrator = false
            // }
        }

        var now = new Date();
    var threeDaysLaterTimeAfterResponse = new Date();
    var responseTimestampFourDaysLater = new Date()
    var responseTimestampDateToSubmitDocuments = new Date()
    var responseTimestampCompleteSubmissionInterrogatoryAndEnquiry = new Date()
    var responseTimestampToAward = new Date()
    var startProceeding = new Date()

    var dateToResponse = new Date(this.props.caseData.claimant_payment_date)
    dateToResponse.setDate(dateToResponse.getDate() + 7);

    if (this.props.caseData.arbitratorStatus !== undefined){
      if (this.props.caseData.arbitratorStatus == 'false' || this.props.caseData.arbitratorStatus  == 'waiting'){
          //if response has been received
          if (this.props.caseData.response !== undefined){
              // then check if three days are over
              threeDaysLaterTimeAfterResponse = new Date(this.props.caseData.response.timestampForCaseProcedure)
              threeDaysLaterTimeAfterResponse.setDate(threeDaysLaterTimeAfterResponse.getDate() + 2);
          }
      }
    }

    if (this.props.caseData.startDateForFurtherProceedings !== undefined){
      
      startProceeding = new Date(this.props.caseData.startDateForFurtherProceedings)
      responseTimestampFourDaysLater = new Date(this.props.caseData.startDateForFurtherProceedings)
      responseTimestampFourDaysLater.setDate(responseTimestampFourDaysLater.getDate() + 4);

      responseTimestampDateToSubmitDocuments = new Date(this.props.caseData.startDateForFurtherProceedings)
      responseTimestampDateToSubmitDocuments.setDate(responseTimestampDateToSubmitDocuments.getDate() + 7);
      
      responseTimestampCompleteSubmissionInterrogatoryAndEnquiry = new Date(this.props.caseData.startDateForFurtherProceedings)
      responseTimestampCompleteSubmissionInterrogatoryAndEnquiry.setDate(responseTimestampCompleteSubmissionInterrogatoryAndEnquiry.getDate() + 11);

      responseTimestampToAward = new Date(this.props.caseData.startDateForFurtherProceedings)
      responseTimestampToAward.setDate(responseTimestampToAward.getDate() + 18);
      
    }

        return(
            <div className={classes.root} style={{ marginTop:'30px' }} >

                {dateOfProceeding != '' && <TableRow hover style={{ height: 16  }}>
                    <TableCell
                        className={classes.row}
                        component="th"
                        scope="row"
                    >
                        {this.context.t("Date of Beginning of Proceedings")}:
                    </TableCell>
                    <TableCell className={classes.row} align="left">
                        {dateOfProceeding.getDate()
                        +'-'+(dateOfProceeding.getMonth()+1)
                        +'-'+dateOfProceeding.getFullYear()
                        +' '+(''+dateOfProceeding.getHours()).padStart(2, '0')
                        +':'+dateOfProceeding.getMinutes()
                        +':'+(''+dateOfProceeding.getSeconds()).padStart(2, '0')}
                    </TableCell>
                </TableRow>}

                <TableRow hover style={{ height: 16  }}>
                    <TableCell
                        className={classes.row}
                        component="th"
                        scope="row"
                    >
                        {this.context.t("Deadline to file the Response")}:
                    </TableCell>
                    <TableCell className={classes.row} align="left">
                        {dateToResponse.getDate()
                        +'-'+(dateToResponse.getMonth()+1)
                        +'-'+dateToResponse.getFullYear()
                        +' '+(''+dateToResponse.getHours()).padStart(2, '0')
                        +':'+dateToResponse.getMinutes()
                        +':'+(''+dateToResponse.getSeconds()).padStart(2, '0')}
                    </TableCell>
                </TableRow>

                {this.props.caseData.arbitratorStatus == 'true' &&  
                    <TableRow hover style={{ height: 16 }}>
                <TableCell
                    className={classes.row}
                    component="th"
                    scope="row"
                >
                    {this.context.t("Deadline for Preliminary Enquiry")}:
                </TableCell>
                <TableCell className={classes.row} align="left">
                    {responseTimestampFourDaysLater.getDate()
                    +'-'+(responseTimestampFourDaysLater.getMonth()+1)
                    +'-'+responseTimestampFourDaysLater.getFullYear()
                    +' '+(''+responseTimestampFourDaysLater.getHours()).padStart(2, '0')
                    +':'+responseTimestampFourDaysLater.getMinutes()
                    +':'+(''+responseTimestampFourDaysLater.getSeconds()).padStart(2, '0')}
                </TableCell>
                </TableRow> 
                }
                {this.props.caseData.arbitratorStatus == 'true' &&  
                    <TableRow hover style={{ height: 16 }}>
                <TableCell
                    className={classes.row}
                    component="th"
                    scope="row"
                >
                    {this.context.t("Deadline to file additional information and documents")}:
                </TableCell>
                <TableCell className={classes.row} align="left">
                    {responseTimestampDateToSubmitDocuments.getDate()
                    +'-'+(responseTimestampDateToSubmitDocuments.getMonth()+1)
                    +'-'+responseTimestampDateToSubmitDocuments.getFullYear()
                    +' '+(''+responseTimestampDateToSubmitDocuments.getHours()).padStart(2, '0')
                    +':'+responseTimestampDateToSubmitDocuments.getMinutes()
                    +':'+(''+responseTimestampDateToSubmitDocuments.getSeconds()).padStart(2, '0')}
                </TableCell>
                </TableRow> 
                }
                {this.props.caseData.arbitratorStatus == 'true' &&  
                    <TableRow hover style={{ height: 16 }}>
                <TableCell
                    className={classes.row}
                    component="th"
                    scope="row"
                >
                    {this.context.t("Deadline for submission, interrogatory, and Enquiry")}:
                </TableCell>
                <TableCell className={classes.row} align="left">
                    {responseTimestampCompleteSubmissionInterrogatoryAndEnquiry.getDate()
                    +'-'+(responseTimestampCompleteSubmissionInterrogatoryAndEnquiry.getMonth()+1)
                    +'-'+responseTimestampCompleteSubmissionInterrogatoryAndEnquiry.getFullYear()
                    +' '+(''+responseTimestampCompleteSubmissionInterrogatoryAndEnquiry.getHours()).padStart(2, '0')
                    +':'+responseTimestampCompleteSubmissionInterrogatoryAndEnquiry.getMinutes()
                    +':'+(''+responseTimestampCompleteSubmissionInterrogatoryAndEnquiry.getSeconds()).padStart(2, '0')}
                </TableCell>
                </TableRow> 
                }
                {this.props.caseData.arbitratorStatus == 'true' &&  
                <TableRow hover style={{ height: 16 }}>
                <TableCell
                    className={classes.row}
                    component="th"
                    scope="row"
                >
                    {this.context.t("Deadline for the delivery of Arbitral Award")}:
                </TableCell>
                <TableCell className={classes.row} align="left">
                    {responseTimestampToAward.getDate()
                    +'-'+(responseTimestampToAward.getMonth()+1)
                    +'-'+responseTimestampToAward.getFullYear()
                    +' '+(''+responseTimestampToAward.getHours()).padStart(2, '0')
                    +':'+responseTimestampToAward.getMinutes()
                    +':'+(''+responseTimestampToAward.getSeconds()).padStart(2, '0')}
                </TableCell>
                </TableRow>
                }
              

            </div>
        
        );
    }
}

const mapStateToProps = (state) => {
    return {
        isLoading: state.uploadDocs.loading,
        files: state.uploadDocs.files,
        userType: state.caseInfo.userType,
        caseId: state.caseInfo.caseId,
        caseData: state.caseInfo.caseData,
    }
}

const mapDispatchToProps = (dispatch) => {
    return {
        addFile: (file, doc_name) => dispatch(actions.addFile(file, doc_name)),
        removeFile: (filename) => dispatch(actions.removeFile(filename)),
        uploadDocs : (files) => dispatch(actions.uploadDocs(files)),
        changeNoOfDays: (caseId, NoOfDays, uniqueId) => dispatch(actions.changeNoOfDays(caseId, NoOfDays, uniqueId))
    }
}

DeadlinePanel.contextTypes = {
    t: PropTypes.func
  }

export default connect(mapStateToProps, mapDispatchToProps)(withStyles(styles)(DeadlinePanel));
